// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Y7E4Y{padding:24px;border-radius:8px;overflow-y:auto;height:fit-content}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `Y7E4Y`
};
export default ___CSS_LOADER_EXPORT___;
